module.exports = __webpack_public_path__ + "static/fonts/Graphik-Regular-Web.d16b552d.eot";